<template>
	<div class="userStatistic w-100">
		<b-col class="content pd-0">
			<b-tabs class="tabs-analytics" v-model="tabActive">
				<b-tab>
					<template v-slot:title>
						<KeyIcon />
						<span>{{ $t('analytics.keywordsSearched') }}</span>
					</template>
					<div class="chart" v-if="!loadingPage">
						<b-row no-gutters>
							<b-col cols="6">
								<div class="pie-chart">
									<PieChart :data="chartData" />
								</div>
							</b-col>
							<b-col cols="6">
								<div class="data-detail">
									<div class="title">
										<span>{{ $t('analytics.keywords') }}</span>
										<span>{{ $t('analytics.times') }}</span>
									</div>
									<div
										class="explain"
										v-if="
											!tabActive &&
												chartData.labels.length &&
												chartData.datasets[0] &&
												chartData.datasets[0].backgroundColor &&
												chartData.datasets[0].backgroundColor.length
										"
									>
										<template v-for="(item, index) in chartData.labels">
											<div class="explain-item" :key="index">
												<div class="data-left">
													<div
														class="color"
														:style="{
															background:
																chartData.datasets[0].backgroundColor[index]
														}"
													></div>
													<span class="keyword">{{ item }}</span>
												</div>
												<div class="data-right">
													{{ chartData.datasets[0].data[index] }}
												</div>
											</div>
										</template>
									</div>
								</div>
							</b-col>
							<b-col cols="12">
								<div class="tips">
									<div class="title">{{ $t('analytics.trick') }}</div>
									<div class="des">
										{{ $t('analytics.trickDetail1')
										}}<router-link
											id="faq"
											:to="$i18nRoute({ name: 'faq' }) + '#12'"
											>{{ $t('analytics.trickDetail2') }}</router-link
										>{{ $t('analytics.and')
										}}<router-link
											id="faq"
											:to="$i18nRoute({ name: 'faq' }) + '#9'"
											>{{ $t('analytics.trickDetail3') }}</router-link
										>{{ $t('analytics.trickDetail4') }}
									</div>
								</div>
							</b-col>
						</b-row>
					</div>
				</b-tab>
				<b-tab>
					<template v-slot:title>
						<VolumIcon />
						<span>{{ $t('analytics.yourListing') }}</span>
					</template>
					<div class="wrap-line-chart" v-if="!loadingPage">
						<div class="details">
							<div class="item">
								<div class="color" style="background: #36A2EB"></div>
								<span class="text">{{
									$t('analytics.chartOfListing.postPromotion')
								}}</span>
							</div>
							<div class="item">
								<div class="color" style="background: #FB6384"></div>
								<span class="text">{{
									$t('analytics.chartOfListing.freeAds')
								}}</span>
							</div>
						</div>
						<div class="line-chart">
							<LineChart
								:chartData="chartData"
								:options="chartOptions"
								:width="760"
								:height="380"
							/>
						</div>
						<div class="tips">
							<div class="title">{{ $t('analytics.trick') }}</div>
							<div class="des">
								{{ $t('analytics.trickDetail1') }}
								<router-link
									id="faq"
									:to="$i18nRoute({ name: 'faq' }) + '#12'"
									>{{ $t('analytics.trickDetail2') }}</router-link
								>{{ $t('analytics.and') }}
								<router-link
									id="faq"
									:to="$i18nRoute({ name: 'faq' }) + '#9'"
									>{{ $t('analytics.trickDetail3') }}</router-link
								>{{ $t('analytics.trickDetail4') }}
							</div>
						</div>
					</div>
				</b-tab>
			</b-tabs>
		</b-col>
		<b-overlay :show="loadingPage" no-wrap></b-overlay>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PieChart from '@/plugins/PieChart';
import LineChart from '@/plugins/LineChart';
// Icons
import KeyIcon from '@/components/icons/IconKey/index';
import VolumIcon from '@/components/icons/IconVolum/index';

export default {
	components: {
		KeyIcon,
		VolumIcon,
		PieChart,
		LineChart
	},
	data() {
		return {
			chartOptions: {
				responsive: false,
				maintainAspectRatio: false,
				scales: {
					gridLines: {
						display: true
					},
					yAxes: [
						{
							id: 'line-one',
							type: 'linear',
							position: 'left'
						},
						{
							id: 'line-two',
							type: 'linear',
							position: 'right',
							beginAtZero: true
						}
					]
				},
				legend: {
					labels: {
						generateLabels: function(chart) {
							return '';
						}
					}
				}
			},
			chartData: {
				labels: [],
				datasets: []
			},
			tabActive: 0,
			loadingPage: false,
			analyticsType: 'Year'
		};
	},
	computed: {
		...mapGetters('UserAnalyticsController', ['analytics'])
	},
	watch: {
		analytics: function(val) {
			if (val) {
				if (this.tabActive) {
					this.chartData = {
						labels: val.labels,
						datasets: [
							{
								fill: false,
								label: this.$t('analytics.chartOfListing.postPromotion'),
								borderColor: '#36A2EB',
								pointBackgroundColor: '#36A2EB',
								yAxisID: 'line-one',
								data: val.listingsPaid
							},
							{
								fill: false,
								label: this.$t('analytics.chartOfListing.freeAds'),
								borderColor: '#FB6384',
								pointBackgroundColor: '#FB6384',
								yAxisID: 'line-two',
								data: val.listingsFree
							}
						]
					};
				} else {
					this.chartData = {
						labels: val.label,
						datasets: [
							{
								backgroundColor: [
									'#FB6384',
									'#FB9F40',
									'#FCCD56',
									'#4BC0C0',
									'#36A2EB'
								],
								data: val.data
							}
						]
					};
					
				}
			}
		},
		analyticsType: function(val) {
			this.getChart(this.tabActive);
		},
		tabActive: function(val) {
			this.analyticsType = 'Year';
			this.getChart(val);
		}
	},
	created() {
		this.getChart(this.tabActive);
	},
	methods: {
		...mapActions('UserAnalyticsController', [
			'USER_GET_ANALYTICS_KEYWORD',
			'USER_GET_ANALYTICS_LISTING'
		]),
		getChart(type = 0) {
			this.loadingPage = true;
			if (type == 1) {
				this.USER_GET_ANALYTICS_LISTING({ type: this.analyticsType })
					.then(result => {
						this.loadingPage = false;
					})
					.catch(err => {
						this.loadingPage = false;
					});
			} else {
				this.USER_GET_ANALYTICS_KEYWORD()
					.then(result => {
						this.loadingPage = false;
					})
					.catch(err => {
						this.loadingPage = false;
					});
			}
		}
	}
};
</script>
<style lang="scss">
@import 'userStatistic.scss';
</style>
